/**
 * Handles actions related to settings that utilise the Rich Text Editor (Quill)
 *
 * @package Ninja Forms builder
 * @subpackage App - Settings Drawer
 * @copyright (c) 2015 WP Ninjas
 * @since 3.0
 */
define( 'controllers/app/rte',[], function() {
	var controller = Marionette.Object.extend( {
		initialize: function() {
			// We don't want the RTE setting to re-render when the value changes.
			nfRadio.channel( 'setting-type-rte' ).reply( 'renderOnChange', function(){ return false } );

			this.listenTo( nfRadio.channel( 'rte' ), 'init:settingModel', this.initSettingModel );

			// When an RTE setting is shown, re-render RTE.
			this.listenTo( nfRadio.channel( 'setting-type-rte' ), 'render:setting', this.renderSetting );

			// When an RTE setting view is destroyed, remove our RTE.
			this.listenTo( nfRadio.channel( 'setting-type-rte' ), 'destroy:setting', this.destroySetting );

			// When an element within the RTE is clicked, check to see if we should insert a link.
			this.listenTo( nfRadio.channel( 'setting-type-rte' ), 'click:extra', this.clickExtra );

			// Instantiates the variable that holds the media library frame.
			this.meta_image_frame;

			this.currentContext = {};
			this.quillInstances = {}; // Track Quill instances
		},

		initSettingModel: function( settingModel ) {
			// Hide the standard merge tag button - we use the one in the Quill toolbar instead
			settingModel.set( 'hide_merge_tags', true );
		},

		initRTE: function( settingModel, dataModel, settingView ) {
			var that = this;
			var settingEl = jQuery( settingView.el ).find( 'div.setting' );

			// Check if already initialized to prevent infinite loop
			if (settingEl.data('quill-initialized')) {
				return;
			}

			// Mark as initialized
			settingEl.data('quill-initialized', true);

			// Clear any existing content and create a container for Quill
			settingEl.empty();

			// Create unique ID for this instance
			var instanceId = 'quill-' + Date.now() + '-' + Math.random().toString(36).substr(2, 9);
			var quillContainer = jQuery('<div id="' + instanceId + '"></div>');
			settingEl.append(quillContainer);

			// Use requestAnimationFrame for better timing
			requestAnimationFrame(function() {
				// Double-check element is still in DOM and attached
				if (jQuery.contains(document, quillContainer[0])) {
					that.initQuillInstance(instanceId, settingModel, dataModel, settingView);
				}
			});
		},

		initQuillInstance: function( instanceId, settingModel, dataModel, settingView ) {
			var that = this;
			var settingEl = jQuery( settingView.el ).find( 'div.setting' );

			// Verify element exists and is in the DOM
			var containerEl = document.getElementById(instanceId);
			if (!containerEl || !jQuery.contains(document, containerEl)) {
				return; // Silently fail if element not found
			}

			// Define custom toolbar
			var toolbarOptions = [
				[{ 'header': [1, 2, 3, false] }],
				['bold', 'italic', 'underline', 'clean'],
				[{ 'list': 'ordered'}, { 'list': 'bullet' }],
				[{ 'align': ['', 'center', 'right', 'justify'] }],
				['nf-link', 'nf-unlink'],
				[{ 'table': 'table' }],
				['nf-undo', 'nf-redo'],
				['nf-media', 'nf-code', 'nf-merge-tags']
			];

			// Initialize Quill
			var quill = new Quill('#' + instanceId, {
				theme: 'snow',
				modules: {
					toolbar: {
						container: toolbarOptions,
						handlers: {
							'nf-link': function() {
								that.showLinkDialog(quill, settingView);
							},
							'nf-unlink': function() {
								that.removeLink(quill);
							},
							'nf-media': function() {
								that.openMediaManager(quill, settingView);
							},
							'nf-merge-tags': function() {
								that.showMergeTags(quill, settingView);
							},
							'nf-code': function() {
								that.toggleCodeView(quill, settingView, settingModel, dataModel);
							},
							'nf-undo': function() {
								quill.history.undo();
							},
							'nf-redo': function() {
								quill.history.redo();
							}
						}
					},
					history: {
						delay: 1000,
						maxStack: 50,
						userOnly: true
					}
				},
				placeholder: ''
			});

			// Set initial content
			var initialValue = dataModel.get( settingModel.get( 'name' ) ) || '';
			quill.root.innerHTML = initialValue;

			// Store instance
			this.quillInstances[instanceId] = {
				quill: quill,
				settingModel: settingModel,
				dataModel: dataModel,
				settingView: settingView
			};

			// Store Quill reference on the editor element for external access
			quill.root.__quill = quill;

			// Also store on the setting element for merge tag button access
			settingEl.data('quill', quill);

			// Add custom button icons using Dashicons
			this.addDashicons(settingView);

			// Manually attach click handler to merge tags button
			// We can't rely on mergeTagBox's automatic attachment since timing is wrong
			setTimeout(function() {
				var toolbar = jQuery(settingView.el).find('.ql-toolbar');
				var mergeButton = toolbar.find('.merge-tags');

				// Remove any existing handlers and attach new one
				mergeButton.off('click').on('click', function(e) {
					var quillInstance = that.quillInstances[instanceId];
					if (!quillInstance) return;

					var quill = quillInstance.quill;

					// Store reference globally for merge tag insertion
					window.nfCurrentQuillInstance = quill;

					// Mark the editor as focused
					jQuery(quill.root).addClass('merge-tag-focus');

					// Get cursor position - use last known position or end of content if no selection
					var range = quill.getSelection();
					var insertIndex;
					if (range) {
						insertIndex = range.index;
					} else {
						// No selection (editor lost focus), insert at end of content
						// getLength() includes the trailing newline, so subtract 1
						insertIndex = Math.max(0, quill.getLength() - 1);
					}

					// Insert a { character to trigger merge tag mode
					quill.insertText(insertIndex, '{');
					quill.setSelection(insertIndex + 1);

					// Set merge tag system variables
					nfRadio.channel('mergeTags').request('set:old', '{');
					nfRadio.channel('mergeTags').request('set:caret', insertIndex + 1);

					// Add overlay class
					var container = jQuery(quill.root).closest('.nf-setting');
					container.find('.ql-container').parent().addClass('merge-tag-focus-overlay');

					// Update tag list
					nfRadio.channel('merge-tags').request('update:taglist', 'fields', false);

					// Show the merge tags box
					jQuery('#merge-tags-box').css('display', 'block');

					// Position it (call focusCallback)
					nfRadio.channel('mergeTags').trigger('focus', quill.root, 'rte');

					// Focus the search input
					setTimeout(function() {
						jQuery('#merge-tags-box').find('.merge-tag-filter').find('input').focus();
					}, 100);
				});
			}, 100);

			// Handle content changes - remove source check so API changes also save
			quill.on('text-change', function(delta, oldDelta, source) {
				var value = quill.root.innerHTML;
				that.updateDataModel(settingModel, dataModel, value);
				nfRadio.channel( 'quill' ).trigger( 'change', settingModel, dataModel, value );
			});

			// Handle focus
			quill.on('selection-change', function(range, oldRange, source) {
				if (range) {
					// Mark the editor as focused for merge tags
					jQuery(quill.root).addClass('merge-tag-focus');
					// Set global reference for merge tag insertion
					window.nfCurrentQuillInstance = quill;
					nfRadio.channel( 'quill' ).trigger( 'focus', settingModel, dataModel, quill );
				} else if (oldRange) {
					jQuery(quill.root).removeClass('merge-tag-focus');
					var value = quill.root.innerHTML;
					that.updateDataModel(settingModel, dataModel, value);
					nfRadio.channel( 'quill' ).trigger( 'blur', settingModel, dataModel, value );
				}
			});

			// Handle text changes for merge tag detection (typing '{')
			var mergeTagBoxLastShown = 0;
			quill.on('text-change', function(delta, oldDelta, source) {
				// Only handle user input, not programmatic changes
				if (source !== 'user') return;

				// Get cursor position
				var range = quill.getSelection();
				var caretPos = range ? range.index : 0;
				nfRadio.channel('mergeTags').request('set:caret', caretPos);

				// Get plain text content (not HTML)
				var content = quill.getText();

				// Find open merge tags in the content
				var mergetags = content.match(/{([a-zA-Z0-9]|:|_|-|})*/g);

				// Filter out closed merge tags
				if (mergetags) {
					mergetags = _.filter(mergetags, function(mergetag) {
						return -1 == mergetag.indexOf('}');
					});
				}

				// If an open merge tag is found, show the Merge Tag Box
				if (mergetags && mergetags.length > 0) {
					nfRadio.channel('mergeTags').request('set:old', mergetags[0]);

					jQuery('#merge-tags-box').css('display', 'block');
					nfRadio.channel('drawer').request('prevent:close');
					jQuery(quill.root).addClass('merge-tag-focus');

					// Store global reference
					window.nfCurrentQuillInstance = quill;

					// Add overlay class
					var container = jQuery(quill.root).closest('.nf-setting');
					container.find('.ql-container').parent().addClass('merge-tag-focus-overlay');

					// Position merge tag box
					nfRadio.channel('mergeTags').trigger('focus', quill.root, 'rte');

					// Filter the tag list
					var value = mergetags[0].replace('{', '');
					nfRadio.channel('merge-tags').request('filtertags', value);

					// Focus the search input (only if box wasn't already visible)
					if (!jQuery('#merge-tags-box').is(':visible') || (Date.now() - mergeTagBoxLastShown > 200)) {
						setTimeout(function() {
							jQuery('#merge-tags-box').find('.merge-tag-filter').find('input').focus();
						}, 100);
					}

					// Track when we showed the box
					mergeTagBoxLastShown = Date.now();
				} else {
					// Hide merge tag box if no open merge tags
					// But don't hide if we just showed it (within 200ms) to prevent flicker
					var timeSinceShown = Date.now() - mergeTagBoxLastShown;
					if (timeSinceShown > 200 && jQuery('#merge-tags-box').is(':visible')) {
						jQuery('#merge-tags-box').css('display', 'none');
						nfRadio.channel('drawer').request('enable:close');
						jQuery('#merge-tags-box').removeClass();
						jQuery('.merge-tag-focus-overlay').removeClass('merge-tag-focus-overlay');
					}
				}
			});

			// Store reference for later
			settingEl.data('quill-instance', instanceId);
		},

		addDashicons: function(settingView) {
			var toolbar = jQuery(settingView.el).find('.ql-toolbar');

			// Replace button content with dashicons
			toolbar.find('.ql-bold').html('<span class="dashicons dashicons-editor-bold"></span>');
			toolbar.find('.ql-italic').html('<span class="dashicons dashicons-editor-italic"></span>');
			toolbar.find('.ql-underline').html('<span class="dashicons dashicons-editor-underline"></span>');
			toolbar.find('.ql-list[value="ordered"]').html('<span class="dashicons dashicons-editor-ol"></span>');
			toolbar.find('.ql-list[value="bullet"]').html('<span class="dashicons dashicons-editor-ul"></span>');
			// Note: Don't replace .ql-align content - it's a dropdown picker that needs its internal structure
			toolbar.find('.ql-clean').html('<span class="dashicons dashicons-editor-removeformatting"></span>');

			// Add custom buttons with dashicons
			toolbar.find('button.ql-nf-link').html('<span class="dashicons dashicons-admin-links"></span>');
			toolbar.find('button.ql-nf-unlink').html('<span class="dashicons dashicons-editor-unlink"></span>');
			toolbar.find('button.ql-nf-media').html('<span class="dashicons dashicons-admin-media"></span>');

			// Find or create merge tags button
			var mergeButton = toolbar.find('button.ql-nf-merge-tags');
			if (mergeButton.length === 0) {
				// Quill didn't create the button, so create it manually in the last .ql-formats group
				var lastFormatsGroup = toolbar.find('.ql-formats').last();
				if (lastFormatsGroup.length === 0) {
					// Create a new formats group if none exists
					lastFormatsGroup = jQuery('<span class="ql-formats"></span>');
					toolbar.append(lastFormatsGroup);
				}
				mergeButton = jQuery('<button type="button" class="ql-nf-merge-tags merge-tags"><span class="dashicons dashicons-list-view"></span></button>');
				lastFormatsGroup.append(mergeButton);
			} else {
				mergeButton.html('<span class="dashicons dashicons-list-view"></span>').addClass('merge-tags');
			}

			toolbar.find('button.ql-nf-code').html('<span class="dashicons dashicons-editor-code"></span>');
			toolbar.find('button.ql-nf-undo').html('<span class="dashicons dashicons-undo"></span>');
			toolbar.find('button.ql-nf-redo').html('<span class="dashicons dashicons-redo"></span>');
		},

		updateDataModel: function( settingModel, dataModel, value ) {
			var name = settingModel.get( 'name' );
			var before = dataModel.get( name );
			var after = value;

			var changes = {
				attr: name,
				before: before,
				after: after
			}

			var label = {
				object: dataModel.get( 'objectType' ),
				label: dataModel.get( 'label' ),
				change: 'Changed ' + settingModel.get( 'label' ) + ' from ' + before + ' to ' + after
			};

			nfRadio.channel( 'changes' ).request( 'register:change', 'changeSetting', dataModel, changes, label );

			dataModel.set( settingModel.get( 'name' ), after );
		},

		renderSetting: function( settingModel, dataModel, settingView ) {
			this.initRTE( settingModel, dataModel, settingView );
		},

		destroySetting: function( settingModel, dataModel, settingView ) {
			this.removeRTE( settingModel, dataModel, settingView );
		},

		removeRTE: function( settingModel, dataModel, settingView ) {
			var settingEl = jQuery( settingView.el ).find( 'div.setting' );
			var instanceId = settingEl.data('quill-instance');

			if (instanceId && this.quillInstances[instanceId]) {
				delete this.quillInstances[instanceId];
			}

			settingEl.empty();
		},

		showLinkDialog: function(quill, settingView) {
			var that = this;
			var range = quill.getSelection(true);
			var text = range ? quill.getText(range.index, range.length) : '';

			// Create link dialog
			var linkDropdown = nfRadio.channel( 'app' ).request( 'get:template', '#tmpl-nf-rte-link-dropdown' );
			var dropdownHtml = linkDropdown({});

			var toolbar = jQuery(settingView.el).find('.ql-toolbar');
			var existingDropdown = toolbar.find('.nf-link-dropdown');

			if (existingDropdown.length) {
				existingDropdown.remove();
				return;
			}

			var dropdown = jQuery('<div class="nf-link-dropdown"></div>').html(dropdownHtml);
			toolbar.append(dropdown);

			dropdown.find('.link-text').val(text);
			dropdown.find('.link-url').focus();

			dropdown.find('.insert-link').on('click', function() {
				var linkText = dropdown.find('.link-text').val();
				var linkUrl = dropdown.find('.link-url').val();
				var newWindow = dropdown.find('.link-new-window').prop('checked');

				if (linkUrl) {
					var format = { link: linkUrl };
					if (newWindow) {
						format.target = '_blank';
					}

					if (range && range.length > 0) {
						quill.formatText(range.index, range.length, format);
					} else if (linkText) {
						quill.insertText(range.index, linkText, format);
						quill.setSelection(range.index + linkText.length);
					}
				}

				dropdown.remove();
			});

			dropdown.find('.cancel-link').on('click', function() {
				dropdown.remove();
			});

			// Store current quill instance for later
			that.currentContext = { quill: quill, range: range };
		},

		removeLink: function(quill) {
			var range = quill.getSelection();
			if (range) {
				quill.formatText(range.index, range.length, { link: false });
			}
		},

		openMediaManager: function(quill, settingView) {
			var that = this;
			var range = quill.getSelection(true);

			// Store context
			this.currentContext = { quill: quill, range: range };

			// If the frame already exists, re-open it.
			if ( this.meta_image_frame ) {
				this.meta_image_frame.open();
				return;
			}

			// Sets up the media library frame
			this.meta_image_frame = wp.media.frames.meta_image_frame = wp.media({
				title: 'Select a file',
				button: { text:  'insert' }
			});

			// Runs when an image is selected.
			this.meta_image_frame.on('select', function(){
				// Grabs the attachment selection and creates a JSON representation of the model.
				var media_attachment = that.meta_image_frame.state().get('selection').first().toJSON();
				that.insertMedia( media_attachment );
			});

			// Opens the media library frame.
			this.meta_image_frame.open();
		},

		insertMedia: function( media ) {
			var quill = this.currentContext.quill;
			var range = this.currentContext.range || quill.getSelection(true) || { index: 0 };

			if ( 'image' == media.type ) {
				quill.insertEmbed(range.index, 'image', media.url);
				quill.setSelection(range.index + 1);
			} else {
				var linkText = media.title || media.filename;
				quill.insertText(range.index, linkText, { link: media.url });
				quill.setSelection(range.index + linkText.length);
			}
		},

		showMergeTags: function(quill, settingView) {
			// Mark the quill root as focused
			jQuery(quill.root).addClass('merge-tag-focus');

			// Store quill reference for merge tag insertion
			this.currentContext = { quill: quill };
		},

		toggleCodeView: function(quill, settingView, settingModel, dataModel) {
			var that = this;
			var container = jQuery(settingView.el).find('.setting');
			var toolbar = jQuery(settingView.el).find('.ql-toolbar');
			var isCodeView = container.hasClass('code-view');

			if (isCodeView) {
				// Switch back to WYSIWYG
				var codeMirror = container.data('codeMirror');
				var code = codeMirror ? codeMirror.getValue() : container.find('textarea').val();
				quill.root.innerHTML = code;
				container.find('.code-view-wrapper').remove();
				container.find('.ql-container').show();
				toolbar.show();
				container.removeClass('code-view');
				container.removeData('codeMirror');

				// Remove active state from code button
				toolbar.find('.ql-nf-code').removeClass('ql-active');
			} else {
				// Switch to code view
				var html = quill.root.innerHTML;
				container.find('.ql-container').hide();

				// Keep toolbar visible but add active state to code button
				toolbar.find('.ql-nf-code').addClass('ql-active');

				// Create wrapper and textarea for CodeMirror
				var wrapper = jQuery('<div class="code-view-wrapper"></div>');
				var textarea = jQuery('<textarea class="code-view-textarea"></textarea>');
				textarea.val(html);
				wrapper.append(textarea);
				container.append(wrapper);
				container.addClass('code-view');

				// Initialize CodeMirror with Monokai theme
				if (typeof CodeMirror !== 'undefined') {
					var codeMirror = CodeMirror.fromTextArea(textarea[0], {
						mode: 'xml',
						theme: 'monokai',
						lineNumbers: true,
						lineWrapping: true,
						viewportMargin: Infinity
					});
					codeMirror.setSize('100%', '200px');
					container.data('codeMirror', codeMirror);

					codeMirror.on('blur', function() {
						var value = codeMirror.getValue();
						that.updateDataModel(settingModel, dataModel, value);
					});
				} else {
					// Fallback if CodeMirror not loaded
					textarea.css({
						'width': '100%',
						'height': '150px',
						'font-family': 'monospace'
					});
					textarea.on('blur', function() {
						var value = jQuery(this).val();
						that.updateDataModel(settingModel, dataModel, value);
					});
				}
			}
		},

		clickExtra: function( e, settingModel, dataModel, settingView ) {
			// Handle any extra click events (like the insert link button)
			var textEl = jQuery( e.target ).parent().find( '.link-text' );
			var urlEl = jQuery( e.target ).parent().find( '.link-url' );
			var isNewWindowEl = jQuery( e.target ).parent().find( '.link-new-window' );

			if ( jQuery( e.target ).hasClass( 'insert-link' ) ) {
				var text = textEl.val();
				var url = urlEl.val();
				var isNewWindow = ( isNewWindowEl.prop( 'checked' ) ) ? true: false;

				if ( 0 != text.length && 0 != url.length && this.currentContext.quill ) {
					var quill = this.currentContext.quill;
					var range = this.currentContext.range || quill.getSelection(true) || { index: 0 };

					var format = { link: url };
					if (isNewWindow) {
						format.target = '_blank';
					}

					quill.insertText(range.index, text, format);
					quill.setSelection(range.index + text.length);
				}
			}

			textEl.val( '' );
			urlEl.val( '' );
			isNewWindowEl.prop( 'checked', false );
			jQuery( e.target ).closest( '.nf-link-dropdown' ).remove();
		}
	});

	return controller;
} );

